<div class="d-flex gap-5 flex-column m-t-30">
   <!--Delivery type-->
   <app-button-toggle nameControl="DeliveryFeeType" textLabel="DeliveryFeeType" [options]="optionsButtonToogle" />

   <!---->
   <!-- By Range -->
   <ng-container [formArrayName]="nameControl()">
      @if(getDeliveryFeeTypeId() === 1) {
      <ng-container *ngFor="let item of feesArray?.controls; let i = index;">
         <div class="row f-column-mobile p-y-10 b-b-custom" [formGroupName]="i">
            <!---->
            <!---->
            <!---->
            <div class="col-sm-2 d-flex flex-column align-items-center">
               <p class="text-gray-100 f-s-10">{{'From' | translate}}</p> {{item.value['RangeFrom']}} Km
            </div>
            <!---->
            <!---->
            <!---->
            <div class="col-sm-3 d-flex flex-column align-items-center">
               <p class="text-gray-100 f-s-10">{{'UpToText' | translate}}</p>
               <mat-form-field appearance="outline" class="hide-hint w-input-mobile">
                  <input kcmsOnlyNumbers matInput formControlName="MaxRange" inputmode="numeric"
                     (blur)="onMaxRangeBlur(i)">
               </mat-form-field>
            </div>
            <!---->
            <!---->
            <!---->
            <div class="col-sm-3 d-flex flex-column align-items-center">
               <p class="text-gray-100 f-s-10">{{'DeliveryFeeValueBrl' | translate}}</p>
               <mat-form-field appearance="outline" class="hide-hint w-input-mobile">
                  <input matInput currencyMask formControlName="Value" inputmode="numeric">
               </mat-form-field>
            </div>
            <!---->
            <!---->
            <!---->
            <div class="col-sm-3 d-flex flex-column align-items-center">
               <p class="text-gray-100 f-s-10">{{'TimeToDeliver' | translate}}</p>
               <mat-form-field appearance="outline" class="hide-hint w-input-mobile">
                  <input kcmsOnlyNumbers matInput formControlName="TimeToDeliver" inputmode="numeric">
               </mat-form-field>
            </div>
            <!---->
            <!---->
            <!---->
            @if(feesArray && feesArray.length > 0 && !viewMode()){
            <div class="col-sm-1 d-flex align-items-center gap-10">
               <i-tabler name="trash" class="icon-20 stroke-1 c-pointer m-l-10 text-error" (click)="onRemoveFee(i)"
                  matTooltip="{{ 'RemoveHour' | translate }}" />
            </div>
            }
         </div>
      </ng-container>
      }
   </ng-container>
   <!---->
   <!-- By Neighborhood -->
   <!---->
   <ng-container [formArrayName]="nameControlByNeighborhoods()">
      @if(getDeliveryFeeTypeId() === 2) {
      <ng-container *ngFor="let item of feesByNeighborhoodArray?.controls; let i = index;">
         <div class="row f-column-mobile p-y-10 b-b-custom" [formGroupName]="i">
            <!---->
            <!---->
            <!---->
            <div class="d-flex flex-column align-items-center col-sm-5">
               <p class="text-gray-100 f-s-10">{{'Neighborhood' | translate}}</p>
               <mat-form-field appearance="outline" class="hide-hint w-input-mobile w-100">
                  <input matInput formControlName="Neighborhood" inputmode="text" [required]="true">
               </mat-form-field>
            </div>
            <div class="col-sm-3 d-flex flex-column align-items-center">
               <p class="text-gray-100 f-s-10">{{'DeliveryFeeValueBrl' | translate}}</p>
               <mat-form-field appearance="outline" class="hide-hint w-input-mobile">
                  <input matInput currencyMask formControlName="Value" inputmode="numeric">
               </mat-form-field>
            </div>
            <div class="col-sm-3 d-flex flex-column align-items-center">
               <p class="text-gray-100 f-s-10">{{'TimeToDeliver' | translate}}</p>
               <mat-form-field appearance="outline" class="hide-hint w-input-mobile">
                  <input kcmsOnlyNumbers matInput formControlName="TimeToDeliver" inputmode="numeric">
               </mat-form-field>
            </div>

            @if(feesByNeighborhoodArray && feesByNeighborhoodArray.length > 0 && !viewMode()){
            <div class="col-sm-1 d-flex align-items-center gap-10">
               <i-tabler name="trash" class="icon-20 stroke-1 c-pointer m-l-10 text-error" (click)="onRemoveFee(i)"
                  matTooltip="{{ 'RemoveHour' | translate }}" />
            </div>
            }
         </div>
      </ng-container>
      }
   </ng-container>
   @if(getDeliveryFeeTypeId()){
   <button mat-stroked-button [disabled]="viewMode()" color="primary" class="w-100 m-t-30" type="button"
      (click)="onAddNewFee()">{{'Add' | translate}}</button>
   }
</div>
